import { Stack, IconButton, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CategoryRow from './CategoryRow';
import { ItemCategory, ItemType } from '../schema';
import { reorderCategories } from '../utils/categoryUtils';

interface Props {
    categories: ItemCategory[];
    onEdit: (category: ItemCategory) => void;
    onDelete: (category: ItemCategory) => void;
    itemTypes: ItemType[];
}

export default function CategoryList({ categories, onEdit, onDelete, itemTypes }: Props) {
    const handleMoveUp = async (index: number) => {
        if (index === 0) return;
        const newOrder = [...categories];
        [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
        const categoryIds = newOrder.map(c => c.id);
        await reorderCategories(categoryIds);
    };

    const handleMoveDown = async (index: number) => {
        if (index === categories.length - 1) return;
        const newOrder = [...categories];
        [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
        const categoryIds = newOrder.map(c => c.id);
        await reorderCategories(categoryIds);
    };

    return (
        <Stack spacing={1}>
            {categories.map((category, index) => (
                <Box key={category.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Stack direction="column" spacing={0.5}>
                        <IconButton size="small" onClick={() => handleMoveUp(index)} disabled={index === 0} sx={{ height: 24, width: 24 }}>
                            <ArrowUpwardIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => handleMoveDown(index)}
                            disabled={index === categories.length - 1}
                            sx={{ height: 24, width: 24 }}
                        >
                            <ArrowDownwardIcon fontSize="small" />
                        </IconButton>
                    </Stack>
                    <Box sx={{ flex: 1 }}>
                        <CategoryRow category={category} onEdit={onEdit} onDelete={onDelete} itemTypes={itemTypes} />
                    </Box>
                </Box>
            ))}
        </Stack>
    );
}
